const Shimmer = ({ className }) => (<span className="animate-pulse block">
        <span className={`bg-gray-200 block ${className}`}/>
    </span>);
export default Shimmer;
